import React, { Component } from 'react';

import './styles/modalDolyameInfo.scss';
import {separate} from "../../../helpers/separate";

export default class ModalDolyameInfo extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedOption: 1
    }
  }

  selectOption(id) {
    this.setState({
      selectedOption: id
    })
  }

  paymentByOption(id) {
    switch (id) {
      case 3:
        return this.props.modalInfo.amount * 1.043 / 3;
      case 6:
        return this.props.modalInfo.amount * 1.078 / 6;
      case 10:
        return this.props.modalInfo.amount * 1.146 / 10;
    }
    return 0;
  }

  render() {
    const { modalInfo } = this.props;

    return (
      <div className="dolyame-info">
        <h2>Тренируйтесь сейчас, платите долями</h2>
        <div className="dolyame-info__options">
          <div className="dolyame-info__options__cont">
            <div onClick={() => this.selectOption(1)} className={'dolyame-info__options__cont__item' + (this.state.selectedOption === 1 ? ' selected' : '')}><span>6 недель</span></div>
            <div onClick={() => this.selectOption(3)} className={'dolyame-info__options__cont__item' + (this.state.selectedOption === 3 ? ' selected' : '')}><span>3 месяца</span></div>
            <div onClick={() => this.selectOption(6)} className={'dolyame-info__options__cont__item' + (this.state.selectedOption === 6 ? ' selected' : '')}><span>6 месяцев</span></div>
            <div onClick={() => this.selectOption(10)} className={'dolyame-info__options__cont__item' + (this.state.selectedOption === 10 ? ' selected' : '')}><span>10 месяцев</span></div>
          </div>
        </div>
        <div className="dolyame-info__payments">
            {
              this.state.selectedOption === 1 ?
                <div className="dolyame-info__payments__cont">
                  {
                    [0, 1, 2, 3].map(number => {
                      return <div className="dolyame-info__payments__item">
                        <p>{number === 0 ? 'Сегодня' : new Date(Date.now() + 12096e5 * number).toLocaleDateString('default', { day: 'numeric', month: 'short' })}</p>
                        <p className="dolyame-info__payments__item__price">{separate(modalInfo.amount / 4)} ₽</p>
                        <div className="dolyame-info__payments__item__line"></div>
                      </div>
                    })
                  }
                </div> :
                  <div className="dolyame-info__payments__cont">
                    <div className="dolyame-info__payments__item">
                      <p>Сегодня</p>
                      <p className="dolyame-info__payments__item__price">0 ₽</p>
                      <div className="dolyame-info__payments__item__line"></div>
                    </div>
                    <div className="dolyame-info__payments__item dolyame-info__payments__item__big">
                      <p>Далее {this.state.selectedOption} платеж{this.state.selectedOption == 3 ? 'а' : 'ей'} с {new Date(Date.now() + 86400000 * 46).toLocaleDateString('default', { day: 'numeric', month: 'short' })}</p>
                      <p className="dolyame-info__payments__item__price">от {Math.round(this.paymentByOption(this.state.selectedOption))} ₽ в месяц</p>
                      <div className="dolyame-info__payments__item__lines">
                      {
                        [...Array(this.state.selectedOption).keys()].map(number => {
                          return <div className="dolyame-info__payments__item__line"></div>
                        })
                      }
                      </div>
                    </div>
                  </div>
            }
          <p className="dolyame-info__payments__comment">Предварительный график платежей. Доступные варианты будут известны после перехода к оплате.</p>
        </div>
      </div>
    )
  }
}